import axios from 'axios';

const baseUrl = (id, isOldSite) => `/api/v1/wire/${id}/${isOldSite}`;

export function like(id, isOldSite) {
  return axios.post(`${baseUrl(id, isOldSite)}/_like`);
}

export function unlike(id, isOldSite) {
  return axios.post(`${baseUrl(id, isOldSite)}/_unlike`);
}
